export const isDiscountArchived = (discount) =>
  Boolean(discount?.archivedAt || discount?.state === 'INACTIVE')

export const isLegacyArchivedDiscount = (discount) =>
  discount?.state === 'INACTIVE' && !discount?.archivedAt

export const canManageDiscountArchive = (user) =>
  user?.role === 'ADMINISTRADOR'

export const getDiscountArchiveActorName = (discount) => {
  const actor = discount?.archivedBy

  if (!actor) return 'Auditoría no disponible'

  return [actor.name, actor.lastName].filter(Boolean).join(' ')
}
